// File: OrderStepper.js
import React, { useEffect, useState } from 'react';
import { Container, Button, Card, Row, Col } from 'react-bootstrap';
import './OrderProcess.css';
import { FaCheck } from 'react-icons/fa';
import SizesStep from './SizesStep';
import AddonsStep from './AddonsStep';
import TypeStep from './TypeStep';
import { getImageUrl, handleCheckUserLogin } from '../../../../MIS/Global';
import { useNavigate, useParams } from 'react-router-dom';
import { useModal } from '../../../ConfirmationModal/ModalContext';
import {
  getAddons_submit,
  getCalc_submit,
  getDetail_submit,
  getPrintAddons_submit,
  handleAddonQuantitySum,
  handleBack,
  handleGetAddons_list,
  handleGetOrder_list,
  handleGetProduct,
  handleGetSettingGST,
  handleGetUser,
  handleNext,
  handleSizePrice
} from './orderModel';
import { decrypt } from '../../../../MIS/encryption';
import PrintType from './PrintType';
import ClothType from './ClothType';
import PrintAddon from './PrintAddon';

const OrderStepper = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { showModal } = useModal();
  const [activeStep, setActiveStep] = useState(0);
  const [selectedCloth, setSelectedCloth] = useState('');
  const [selectedClothType, setSelectedClothType] = useState('');
  const [selectedType, setSelectedType] = useState('');
  const [sizeOptions, setSizeOptions] = useState([]);
  const [addonOptions, setAddonOptions] = useState([]);
  const [user, setUser] = useState({});
  const [product, setProduct] = useState({});
  const [gstPercent, setGstPercent] = useState(null);
  const [loading, setLoading] = useState(false);
  const [quoteLoading, setQuoteLoading] = useState(false);
  const [quotations, setQuotations] = useState([]);
  const [printAddons, setPrintAddons] = useState([]);

  const data = {
    pid: user?.id,
    party_name: user?.ownerName,
    party_mob: user?.mob,
    party_state: user?.state,
    party_city: user?.city,
    party_pinCode: user?.postalCode,
    party_address: user?.address,
    quote_no:quotations?.[0]?.quote_no || "-",    
    quote_status: quotations?.[0]?.quote_status || "Pending",
    sub_total: getCalc_submit({ gstPercent, addonOptions, sizeOptions, isType: 'sub' }),
    discount: 0,
    gst_percent: Number(gstPercent).toFixed(2),
    s_gst: getCalc_submit({ gstPercent, addonOptions, sizeOptions, isType: 'gst' }),
    c_gst: getCalc_submit({ gstPercent, addonOptions, sizeOptions, isType: 'gst' }),
    grand_total: getCalc_submit({ gstPercent, addonOptions, sizeOptions, isType: 'grand_total' }),
    paid_amount: 0,
    balance_amount: 0,
    login_id: user?.id,
    quote_type: selectedType,
    addons_total: getCalc_submit({ gstPercent, addonOptions, sizeOptions, isType: 'addon' }),
    item_image: product?.id,
    cloth_name: selectedClothType?.cloth_name,
    print_name:selectedCloth?.print_type_name,
    cloth_rate: selectedClothType?.sub_price,
    print_type_id:selectedCloth?.id,
    cloth_id:selectedClothType?.id,
    details: getDetail_submit({ sizeOptions, product,quotations}),
    addons: getAddons_submit({ addonOptions,quotations }) || [],
    prints: getPrintAddons_submit({ printAddons,quotations }) || [],
  };

  const steps = [
    { label: 'Type', component: <TypeStep selectedType={selectedType} setSelectedType={setSelectedType} quote={quotations}/> },
    { label: 'Print Type', component: <PrintType selectedCloth={selectedCloth} setSelectedCloth={setSelectedCloth} quote={quotations}/> },
    { label: 'Cloth', component: <ClothType selectedCloth={selectedCloth} selectedClothType={selectedClothType} setSelectedClothType={setSelectedClothType} quote={quotations}/> },
    {
      label: 'Sizes',
      component: <SizesStep
        sizeOptions={sizeOptions}
        setSizeOptions={setSizeOptions}
        selectedType={selectedType}
        selectedCloth={selectedCloth}
        quote={quotations}
        addonOptions={addonOptions}
        setAddonOptions={setAddonOptions}
        selectedClothType={selectedClothType}
      />
    },
    { label: 'Addons', component: <AddonsStep addonOptions={addonOptions} setAddonOptions={setAddonOptions} sizeOptions={sizeOptions} quote={quotations}/> },
    { label: 'Print Addons', component: <PrintAddon printAddons={printAddons} setPrintAddons={setPrintAddons} quote={quotations}/> },
  ];

  const handleStepClick = (index) => setActiveStep(index);

  useEffect(() => {
    const data = decrypt(id);
    const parts = data.split("-");
    if (parts?.[2]) {      
      let filter={page:1,limit:1,id:parts?.[2]}
      handleGetOrder_list({filter,setQuotations,setQuoteLoading})
    }
  },[]);
  useEffect(() => {
    if(quotations?.length > 0){
    if (addonOptions?.length <= 0) {
      let quote=quotations;
      handleGetAddons_list({ setLoading, setAddonOptions,quote });
    }
  }
  }, [quotations]);
  
  useEffect(() => {
    const isLogin = handleCheckUserLogin("userData", "id");
    if (isLogin <= 0) {
      navigate(`/`);
    } else {
      if (!user || Object.keys(user).length === 0) {
        handleGetUser({ id: isLogin, setUser });
      }
    }
  }, []);

  useEffect(() => {
    if (!product || Object.keys(product).length === 0) {
      const data = decrypt(id);
      const parts = data.split("-");
      handleGetProduct({ id: parts[0], setProduct });
    }
    if (gstPercent == null) {
      handleGetSettingGST({ setGstPercent });
    }
  }, []);

  useEffect(() => {
    if(sizeOptions.length > 0){
      const updatedAddons = addonOptions?.map((addon) => {
        if (parseInt(addon?.addon_qty) > 0) {
          return {
            ...addon,          
            addon_qty: handleAddonQuantitySum(sizeOptions),
            addons_amount:Number((handleAddonQuantitySum(sizeOptions)) * addon?.addons_price).toFixed(2)
          };
        }
        return {...addon};
      });
      setAddonOptions(updatedAddons);
    }
  }, [sizeOptions]);
  return (
    <Container className="order-stepper-container mt-4">        
      <h4 className="mb-3 fw-semibold text-start">Order {quotations?.length > 0 ? `#: ${quotations?.[0]?.quote_no}`:''}</h4>
      <Row>
        {/* Product Info - Left on md+, top on mobile */}
        <Col xs={12} md={4} className="mb-4">
          <Card className="shadow-sm">
            <Card.Body>
              {product?.id ? (
                <>
                  <div className="text-center mb-3">                  
                    <img
                      src={getImageUrl(`/media/${product?.imgpath}`)|| '/no-image.jpg'}
                      alt={product?.productname || 'Product Image'}
                      className="img-fluid rounded"
                      style={{ maxHeight: '200px', objectFit: 'contain' }}
                    />
                  </div>
                  <h5 className="mb-2 text-center">{product?.productname || "Product Name"}</h5>
                  <p className="text-muted text-center small mb-3">Product Code: {product?.productcode}</p>

                  <ul className="list-group list-group-flush">
                    <li className="list-group-item d-flex justify-content-between align-items-center">
                      Sub Total:
                      <span>₹{quotations?.length > 0 && getCalc_submit({ gstPercent, addonOptions, sizeOptions, isType: 'size' })  <= 0 
                      ? Number(Number(quotations?.[0]?.sub_total)-Number(quotations?.[0]?.addons_total)).toFixed(2)
                      : getCalc_submit({ gstPercent, addonOptions, sizeOptions, isType: 'size' })
                      }</span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center">
                      Addon Total:
                      <span>₹{quotations?.length > 0 && getCalc_submit({ gstPercent, addonOptions, sizeOptions, isType: 'addon'}) <= 0
                       ? Number(quotations?.[0]?.addons_total).toFixed(2)
                       :getCalc_submit({ gstPercent, addonOptions, sizeOptions, isType: 'addon'})
                      }</span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center fw-bold">
                      Grand Total:
                      <span>₹{
                        quotations?.length > 0 && getCalc_submit({ gstPercent, addonOptions, sizeOptions, isType: 'grand_total'}) <= 0
                        ? Number(quotations?.[0]?.grand_total).toFixed(2)
                        : sizeOptions?.length <= 0 &&  quotations?.length > 0
                        ? Number(quotations?.[0]?.grand_total).toFixed(2)
                        : getCalc_submit({ gstPercent, addonOptions, sizeOptions, isType: 'grand_total'})}</span>
                    </li>
                  </ul>
                </>
              ) : (
                <p className="text-center text-muted">Loading product info...</p>
              )}
            </Card.Body>
          </Card>
        </Col>

        {/* Order Steps - Right on md+, bottom on mobile */}
        <Col xs={12} md={8}>
        {quoteLoading ? (
          <div className="text-center my-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
         ) : (
          <>
          <Card className="shadow-sm">
            <Card.Body>
            <div className="new-stepper mb-4">
              {steps.map((step, index) => (
                <div
                  key={index}
                  className={`step-item ${index === activeStep ? 'active' : ''} ${index < activeStep ? 'completed' : ''}`}
                  onClick={() => {
                    if (!quotations?.length > 0) {
                      handleStepClick(index);
                    }
                  }}
                >
                  <div className="step-index">
                    {index < activeStep ? <FaCheck size={12} /> : index + 1}
                  </div>
                  <div className="step-label">{step.label}</div>
                </div>
              ))}
            </div>

              <div className="step-content mb-4">{steps[activeStep].component}</div>

              <div className="d-flex justify-content-between">
                <Button
                  variant="outline-secondary"
                  onClick={() => handleBack({ activeStep, setActiveStep })}
                  disabled={activeStep === 0}
                  size="sm"
                >
                  Back
                </Button>

                <Button
                  variant="primary"
                  onClick={() =>
                    handleNext({
                      activeStep,
                      setActiveStep,
                      selectedCloth,
                      sizeOptions,
                      showModal,
                      steps,
                      setLoading,
                      data,
                      navigate,
                      selectedClothType,
                      id:quotations?.[0]?.id || 0
                    })
                  }
                  size="sm"
                >
                  {loading  ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Submitting...
                    </>
                  ) : activeStep === steps.length - 1 ? "Submit" : "Next"}
                </Button>
              </div>
            </Card.Body>
          </Card>
          </>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default OrderStepper;
